/*

====================================================
图片命名约定
====================================================
 
格式：{SKU小写}-{序号}.ext
例：
  uhd-1240-1.jpg / uhd-1240-2.jpg / uhd-1240-3.jpg
  uhd-1240x-1.jpg / uhd-1240x-2.jpg
  shared-1.jpg   ← 公共图，所有变体下都显示
 
规则：
- SKU 与 Shopify 后台一致，文件名统一转小写
- 序号是最后一段，用 - 分隔
- 公共图前缀用 shared / common / all 其中之一
====================================================

*/




(function () {
  // 公共图前缀，任何变体下都显示
  const PUBLIC_PREFIXES = ['shared', 'common', 'all'];

  // ——— 工具函数 ———

  function getSectionId(el) {
    const section = el.closest('[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function getVariantOptionMap(sectionId) {
    const el = document.getElementById(`variant-option-map-${sectionId}`);
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch { return {}; }
  }

  // 从文件名提取前缀
  // 约定：{选项值}-{序号}.jpg，序号永远是最后一段
  // 例：uhd-1240-1.jpg → uhd-1240
  function getPrefix(filename) {
    const name = filename.split('.')[0];   // 去掉扩展名
    const parts = name.split('-');         // 按 - 分割
    parts.pop();                           // 去掉最后的序号
    return parts.join('-').toLowerCase();  // 重新拼接
  }

  // ——— 核心过滤函数 ———

  function filterGallery(sectionId, optionValue) {
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    if (!gallery) return;

    const items = gallery.querySelectorAll('.product__media-item');
    let firstVisible = null;

    items.forEach((item) => {
      const img = item.querySelector('img');
      const src = img?.src || img?.dataset.src || '';
      const filename = src.split('/').pop().split('?')[0];
      const prefix = getPrefix(filename);
      const isPublic = !prefix || PUBLIC_PREFIXES.includes(prefix);
      const isMatch  = optionValue && prefix === optionValue;
      const show = isPublic || isMatch;

      item.style.display = show ? '' : 'none';
      item.toggleAttribute('aria-hidden', !show);
      if (show && !firstVisible) firstVisible = item;
    });

    syncThumbnails(sectionId);

    // 主动接管激活图，与 Dawn 原生逻辑对齐，避免冲突
    if (firstVisible) {
      const mediaGallery = document.querySelector(`media-gallery[id="MediaGallery-${sectionId}"]`);
      mediaGallery?.setActiveMedia?.(firstVisible.dataset.mediaId, true);
    }
  }

  function syncThumbnails(sectionId) {
    const thumbList = document.querySelector(
      `#GalleryThumbnails-${sectionId} .thumbnail-list`
    );
    if (!thumbList) return;

    thumbList.querySelectorAll('.thumbnail-list__item').forEach((thumb) => {
      const target = thumb.dataset.target;
      if (!target) return;
      const mainItem = document.querySelector(`[data-media-id="${target}"]`);
      // 找不到 或 没有 data-media-filename（featured media）默认显示
      if (!mainItem || !mainItem.dataset.mediaFilename) {
      thumb.style.display = '';
      return;
      }
      thumb.style.display = mainItem.style.display;
    });
  }

  // ——— 初始化 ———

  function initSection(sectionEl) {
    const sectionId = sectionEl.id.replace('shopify-section-', '');
    const variantOptionMap = getVariantOptionMap(sectionId);
    if (!Object.keys(variantOptionMap).length) return;

    const variantSelect = sectionEl.querySelector('[name="id"]');
    if (!variantSelect) return;

    const optionValue = variantOptionMap[variantSelect.value];
    if (optionValue) filterGallery(sectionId, optionValue);
  }

  // ——— 事件监听 ———

  // 捕获阶段监听 change 事件，name="id" 是 Shopify 变体隐藏 input
  document.addEventListener('change', (e) => {
    if (e.target.name !== 'id') return;

    const sectionId = getSectionId(e.target);
    if (!sectionId) return;

    const variantOptionMap = getVariantOptionMap(sectionId);
    const optionValue = variantOptionMap[e.target.value];
    filterGallery(sectionId, optionValue || '');
  }, true); // true = 捕获阶段

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(initSection);
  });

})();